import React, { useCallback } from 'react';
import FormField from './FormField';
import { useTranslation } from 'react-i18next';
import { Button, Box } from '@chakra-ui/react';

const PasswordField = () => {
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    location.href = '/users/edit';
  }, []);

  return (
    <FormField label={t('users.membership.member_info.password')}>
      <Box mt="9px" textAlign="left">
        <Button
          variant="textButton"
          className="member-center-profile__text-button"
          onClick={handleClick}
          data-e2e-id="member-center-profile-password-setting_button"
        >
          {t('users.membership.member_info.password.change')}
        </Button>
      </Box>
    </FormField>
  );
};

export default PasswordField;
